import React, { useEffect, useState } from 'react'
import { CButton, CCard, CCardBody, CCardTitle, CCardText, CCol, CImage } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilArrowCircleLeft } from '@coreui/icons'
import apiClient from '../../services/apiClient'
import { buildApiUrl } from '../../utils/getConfiguration'

const SupplierDetail = () => {
  const [recommendations, setRecommendations] = useState([])

  const fetchRecommendationsData = async () => {
    try {
      const grp_ID = localStorage.getItem('grp_ID')
      const response = await apiClient.get(buildApiUrl('suppliers', { grp_ID }))
      setRecommendations(response.data)
    } catch (error) {
      console.error('Error fetching recommendations', error)
    }
  }

  useEffect(() => {
    fetchRecommendationsData()
  }, [])

  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CCol sm={12}>
            <h4 id="traffic" className="card-title mb-0">
              <p id="caption 2">Supplier Detail description</p>
              <hr></hr>
              <CButton
                color="primary"
                onClick={() => {
                  //localStorage.removeItem('loginName1')
                  //localStorage.removeItem('wizard')
                  console.log('Back')
                  window.history.back()
                }}
              >
                <CIcon icon={cilArrowCircleLeft} size="xxl" />
              </CButton>
              <hr></hr>
            </h4>
            <div className="small text-medium-emphasis">
              {recommendations.length > 0 && (
                <div>
                  {recommendations.map((recommendation) => {
                    const selectedId = localStorage.getItem('supplierid')
                    const recommendationId =
                      recommendation?.supplier_id ?? recommendation?.supplier_ID
                    if (String(recommendationId ?? '') !== String(selectedId ?? '')) {
                      return null
                    }

                    return (
                      <div key={String(recommendationId)}>
                        <div>
                          <CCard>
                            <CCardBody>
                              <CCol sm={12}>
                                <CImage
                                  className="p-3"
                                  rounded
                                  orientation="top"
                                  src={`https://displatform.com/assets/suppliers/${recommendation.supplierPic}`}
                                  style={{
                                    maxWidth: '100%',
                                    height: 'auto',
                                  }}
                                />
                                <CCardText style={{ textAlign: 'justify' }}>
                                  {recommendation.description}
                                </CCardText>
                                <hr />
                                <CCardText className="p-1">
                                  Mail:{' '}
                                  {recommendation.supplierMail ? (
                                    <a href={`mailto:${recommendation.supplierMail}`}>
                                      {recommendation.supplierMail}
                                    </a>
                                  ) : (
                                    'N/A'
                                  )}
                                </CCardText>
                                <CCardText className="p-1">
                                  Phone: {recommendation.supplierPhone}
                                </CCardText>
                                <CCardText className="p-1">
                                  Link: {recommendation.supplierLink}
                                </CCardText>
                              </CCol>
                            </CCardBody>
                          </CCard>
                        </div>
                      </div>
                    )
                  })}
                </div>
              )}
            </div>
          </CCol>
        </CCardBody>
      </CCard>
      <CCard>
        <CCardBody>
          <CCol sm={12}>
            {/*<CCardImage orientation="top" src={avatar2} />
            <CCardTitle>{recommendation.Title}</CCardTitle>
            <CCardText>{recommendation.Description}</CCardText>*/}
            <CButton
              color="primary"
              onClick={() => {
                //localStorage.removeItem('loginName1')
                //localStorage.removeItem('wizard')
                console.log('Back')
                window.history.back()
              }}
            >
              <CIcon icon={cilArrowCircleLeft} size="xxl" />
            </CButton>
          </CCol>
        </CCardBody>
      </CCard>
    </>
  )
}

export default SupplierDetail
